export default __webpack_public_path__ + "static/superbetter-1-0583fa21ceeb0548c6aab3cc94b4ed70.webp";